import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('REPORTINGS').plugin(axiosPlugin, {template: "array"});

let fetchReportingsAction = redux.fetchActionGet();


export const fetchReportings = (query = {}) => fetchReportingsAction(`/reportings?${queryString.stringify(query)}`);
export const resetReportings = () => redux.actions.reset();

export const reportings = redux.reducer();